import React from 'react';

import {SITE} from 'features/ui/enums';
import {StageStatus} from 'features/search/filters/enums';
import {getCurrentSite} from 'features/services/utils/env-helper';

import './_statusLegend.scss';

import {Icon} from 'components/atoms/Media/Icon';
import { Tags, TagDesign } from '@atoms/Tags/Tags';

export const StatusLegend: React.FunctionComponent = ({  }) => {

    const [visible, setVisible] = React.useState(true);

    const onCloseClick = () => {
        setVisible(false);
    };

    if(!visible) return null;

    return (
        <div className="status-legend">

            <div className="status-legend__close" onClick={onCloseClick}>
                <Icon name="x" size={16} />
            </div>

            {/*<P xtraSmallMargin>Kartikoner</P>*/}

            <ul>
                <li>
                    <Tags 
                        tagDesign={TagDesign.DOT} 
                        status={StageStatus.FORSALE} 
                        className='status' 
                    />
                </li>
                <li>
                    <Tags 
                        tagDesign={TagDesign.DOT} 
                        status={StageStatus.PLANNED} 
                        className='status' 
                    />
                </li>
                <li>
                    <Tags 
                        tagDesign={TagDesign.DOT} 
                        status={getCurrentSite() === SITE.FI 
                            ? StageStatus.PRESELLING 
                            : StageStatus.VIP
                        } 
                        className='status' 
                    />
                </li>
                <li>
                    <Tags 
                        tagDesign={TagDesign.DOT} 
                        status={StageStatus.SOLD_OUT} 
                        className='status' 
                    />
                </li>
            </ul>
        </div>
    );
};

